import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { FormRowComponent, FormRowElement, Indent, InputComponent, UISizes } from 'LibNeo'
import { FieldNames } from 'Constants/FieldNames'
import { FormNames } from 'Constants/FormNames'
import { BgLimitRequestFull, bgLimitRequestSelector } from 'Pages/ibro'
import { formsSelectors } from 'Modules'

export const StartFields: FC = () => {
	const item = useSelector(bgLimitRequestSelector.selectCurrentLimitRequest) as BgLimitRequestFull
	const getForm = useSelector(formsSelectors.getGlobalForm)
	const form = getForm(FormNames.BROKER.LIMIT)

	return (
		<Indent top={40}>
			<FormRowComponent isString label="Наименование">
				<FormRowElement size={UISizes.MEDIUM} fixWidth>
					{item[FieldNames.NAME]}

					<InputComponent
						fieldName={FieldNames.NAME}
						form={form}
						fieldOptions={{
							initialValue: item[FieldNames.NAME],
						}}
						type="hidden"
					/>
				</FormRowElement>
			</FormRowComponent>

			<FormRowComponent isString label="ИНН">
				<FormRowElement size={UISizes.MEDIUM} fixWidth>
					{item[FieldNames.INN]}

					<InputComponent
						fieldName={FieldNames.INN}
						form={form}
						fieldOptions={{
							initialValue: item[FieldNames.INN],
						}}
						type="hidden"
					/>
				</FormRowElement>
			</FormRowComponent>
		</Indent>
	)
}
